module.exports = __webpack_public_path__ + "img/statement-01@2x.d45b14d7.svg";